import {
    POST_ASSIGN_INSPECTOR, POST_WAIVEOFF_INSPECTION, GET_ALL_INSPECTORS_WITH_TYPE,
    POST_ACCEPT_REJECT_INSPECTION, GET_INSPECTION_DETAILS_BY_INSPECTORID,GET_INSPECTION_DETAILS_BY_INSPECTORID_FOR_DASHBOARD,
    GET_INSPECTOR_ALLOCATIONS_BY_INSPECTOR_ID, GET_INSPECTOR_ALLOCATIONS,
    GET_INSPECTION_DETAILS_BY_CALLID, PATCH_UPDATE_INSPECTION_STATUS,
    SUPPLIER_INSPECTION, GET_CALL_LINEITEM_DETAILS_BY_CALLID, CHANGE_SUPPLIER_DOCUMENT_STATUS,
    GET_DOCUMENTS_UPLOADED_BY_INSPECTOR, GET_ALL_CALLS, GET_NEW_INSPECTIONS_BY_INSPECTORID,
    POST_REJECTHOLDINSPECTION,
} from '../type'

const initialState = {
    inspectionDetailsByInspectorId: [],
    inspectionDetailsByInspectorIdforDashboard: [],
    allinspectorswithtypes: [],
    inspectorallocation: [],
    inspectionDetailsByCallID: [],
    loading: true,
    supplierInspection: [],
    inspectionLineItemDetailsByCallID: [],
    documentData: [],
    inspectorallocationAll: [],
    allCalls: [],
    newCalls: [],
    rejectholdinspection: [],
}

export default function inspectionReducer(state = initialState, action) {
    switch (action.type) {

        case GET_INSPECTION_DETAILS_BY_INSPECTORID:
            return {
                ...state,
                inspectionDetailsByInspectorId: action.payload,
                loading: false
            }
         
        case GET_INSPECTION_DETAILS_BY_INSPECTORID_FOR_DASHBOARD:
                return {
                    ...state,
                    inspectionDetailsByInspectorIdforDashboard: action.payload,
                    loading: false
                }    

        case POST_ACCEPT_REJECT_INSPECTION:
            return {
                ...state,
                loading: false
            }

        case POST_WAIVEOFF_INSPECTION:
            return {
                ...state,
                loading: false
            }

        case POST_ASSIGN_INSPECTOR:
            return {
                ...state,
                loading: false
            }
        case GET_ALL_INSPECTORS_WITH_TYPE:
            return {
                ...state,
                allinspectorswithtypes: action.payload,
                loading: false
            }
        case GET_INSPECTOR_ALLOCATIONS_BY_INSPECTOR_ID:
            return {
                ...state,
                inspectorallocation: action.payload,
                loading: false
            }
        case GET_INSPECTION_DETAILS_BY_CALLID:
            return {
                ...state,
                inspectionDetailsByCallID: action.payload,
                loading: false
            }

        case GET_CALL_LINEITEM_DETAILS_BY_CALLID:
            return {
                ...state,
                inspectionLineItemDetailsByCallID: action.payload,
                loading: false
            }

        case PATCH_UPDATE_INSPECTION_STATUS:
            return {
                ...state,
                loading: false
            }


        case SUPPLIER_INSPECTION:
            return {
                ...state,
                supplierInspection: action.payload,
                loading: false
            }

        case CHANGE_SUPPLIER_DOCUMENT_STATUS:
            return {
                ...state,
                loading: false

            }
        case GET_DOCUMENTS_UPLOADED_BY_INSPECTOR:
            return {
                ...state,
                documentData: action.payload,
                loading: false
            }
        case GET_INSPECTOR_ALLOCATIONS:
            return {
                ...state,
                inspectorallocationAll: action.payload,
                loading: false
            }
        case GET_ALL_CALLS:
            return {
                ...state,
                allCalls: action.payload,
                loading: false
            }
        case GET_NEW_INSPECTIONS_BY_INSPECTORID:
            return {
                ...state,
                newCalls: action.payload,
                loading: false
            }
        case POST_REJECTHOLDINSPECTION:
            return {
                ...state,
                rejectholdinspection: action.payload,
                loading: false
            }

        default: return state
    }
}